export { default } from './FilterCompositionTags';
